import React, {PureComponent} from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

import Slider from "@irati/ui/src/Slider"
import connect from "@irati/store/connect"
import {RouterLink} from "@irati/ui/src/Link"
import media, {minWidthMedia} from "@irati/ui/src/global/media"
import History from "@irati/utils/history"
import {geolocationTracking} from "@irati-tracking/geolocation"
import DealResult from "../DealResult/DealResult"

const StyledDealResult = styled(DealResult)`
  ${minWidthMedia.desktop`
    margin-bottom: 10px;
  `}

  ${media.desktop`
    margin: 1px 0px 1px 15px;
    ${RouterLink}{
      user-drag: none;
    }
  `}
`

class Cards extends PureComponent {
  static contextTypes = {
    apps: PropTypes.object.isRequired
  }

  static propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      deal: PropTypes.object,
      number: PropTypes.number,
      proximityMeters: PropTypes.number,
      locations: PropTypes.array
    })).isRequired,
    onCardSelection: PropTypes.func,
    searchTerm: PropTypes.string
  }

  static defaultProps = {
    onCardSelection: () => {},
    searchTerm: ""
  }

  constructor(props) {
    super(props)
    this.sliderIsDragging = false
    this.shouldTriggerCardSelection = true
    this.cardsWrapperProps = {
      // Slider settings
      settings: {
        infinite: false,
        draggable: true,
        slidesToShow: 1.1,
        slidesToScroll: 1,
        arrows: false,
        beforeChange: () => { this.sliderIsDragging = true },
        afterChange: (sliderIndex) => {
          this.sliderIsDragging = false
          this.handleSliderChange(sliderIndex)
        }
      }
    }
  }

  handleSliderChange = (sliderIndex) => {
    const {data, onCardSelection} = this.props
    if (this.shouldTriggerCardSelection && data.length) {
      onCardSelection(data[sliderIndex].locations[0])
    }
    this.shouldTriggerCardSelection = true
  }

  handleCardClick = (selectedDeal, nearestLocation) => {
    const {isPhone, onCardSelection, searchTerm} = this.props
    if (isPhone) {
      /*
        This is a workaround for a react-slick bug which triggers the onclick on the cards
        when you drag on non-touch devices
      */
      if (!this.sliderIsDragging) {
        geolocationTracking.searchByLocationClickViewPerk("list", searchTerm)
        History.push(`/info/${selectedDeal.urlSlug}`, this.context.apps.PERKS)
      }
    } else {
      onCardSelection(nearestLocation)
    }
  }

  goToSliderIndex = (index) => {
    this.shouldTriggerCardSelection = false
    this.cardsSlider.slickSlider.current.slickGoTo(index)
  }

  handleViewPerkDetailClick = (ev) => {
    ev.stopPropagation()
    geolocationTracking.searchByLocationClickViewPerk("list", this.props.searchTerm)
  }

  render() {
    const {isPhone, data} = this.props
    const CardsWrapper = isPhone ? Slider : styled.div``

    return (
      <CardsWrapper ref={(c) => { this.cardsSlider = c }} {...this.cardsWrapperProps}>
        {data.map((deal) => (
          <StyledDealResult
            key={deal.key}
            deal={deal.deal}
            shouldLinkToDealOnClick={false}
            showViewPerkDetailLink={!isPhone}
            badgeNumber={deal.number}
            proximityMeters={deal.proximityMeters}
            locations={deal.locations}
            onClick={() => { this.handleCardClick(deal.deal, deal.locations[0]) }}
            onViewPerkDetailClick={this.handleViewPerkDetailClick} />
        ))}
      </CardsWrapper>
    )
  }
}

const mapStateToProps = ({mq}) => ({isPhone: mq.lessThan.large})

export default connect(mapStateToProps, null, null, {withRef: true})(Cards)
